import { StorageState } from '../../../../reducers';
import { createDataFetchSliceSelectors } from '../../../../utils/dataFetch';


export const accountStatisticChargesSliceSelector = (state: StorageState) => state.accounts.statistic.charges;

export const accountStatisticChargesSelectors = createDataFetchSliceSelectors(
    accountStatisticChargesSliceSelector
);
